<style>
.table-dashboard thead tr td {
  background: #1f2248;
  color: #fff;
}
</style>
<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title="Laporan Terimaan Harian Mengikut Jenis">
            <w-form ref="dform" @validate="search">
                
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                      <w-input v-model="cari.tarikh_dari" required label="Dari" type="date"  /> 
                      <z-lookup
                            label="Jabatan"
                            :url="service_kutipan + 'lookup/jabatan_user'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.jabatan_id"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <w-input v-model="cari.tarikh_hingga" required label="Hingga" type="date"  /> 
                        <z-lookup
                            label="Jenis Kaunter"
                            :url="service_laporan + 'lookup/lkp_kaunter_baharu'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_kaunter_id"
                        />
                    </div>
                    
                </w-flex>

            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1 " @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>
            <center v-if="loading == true"><w-progress class="ma1" circle></w-progress></center>
            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode">                
                <table class="table-dashboard" width="38%" style="float:left;">
                    <thead>
                        <tr>
                            <td style="text-align:center;" colspan="4">Ringkasan Terimaan</td>
                        </tr>
                        <tr>
                            <td>Bil.</td>
                            <td>Kod Akaun</td>
                            <td>Bil. Urusniaga</td>
                            <td>Amaun (RM)</td>
                        </tr>
                    </thead>
                    <tbody>
                      <template v-if="table.items.length > 0">
                        <tr v-for="dt, index in table_akaun.items">
                            <td>{{dt.bil}}</td>
                            <td>{{dt.kod_akaun}}</td>
                            <td>{{dt.bil_terima}}</td>
                            <td>{{dt.amaun_terima}}</td>
                        </tr>
                      </template>
                      <template v-else>
                          <tr>
                              <td colspan="4" style="text-align: center">Tiada Rekod</td>
                          </tr>
                      </template>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="2"><b>Jumlah Terimaan<br>(Mengikut Charge Line)</b></td>
                            <td><b>{{table_akaun.total_bil_terima}}</b></td>
                            <td><b>{{table_akaun.total_amaun_terima}}</b></td>
                        </tr>
                        <tr>
                            <td colspan="2"><b>Bilangan Urusniaga Batal</b></td>
                            <td><b>{{table_akaun.total_bil_batal}}</b></td>
                            <td><b>{{table_akaun.total_amaun_batal}}</b></td>
                        </tr>
                        <tr>
                            <td colspan="2"><b>Bilangan Urusniaga Diterima</b></td>
                            <td><b>{{table_akaun.selisih_bil}}</b></td>
                            <td><b>{{table_akaun.selisih_amaun}}</b></td>
                        </tr>
                    </tfoot>

                </table>
                <table class="table-dashboard" width="60%" style="float:right;">
                    <thead>
                        <tr>
                            <td rowspan="2">Ringkasan Terimaan</td>
                            <td colspan="2">Penerimaan Rekod</td>
                            <td colspan="2">Pembatalan Rekod</td>
                        </tr>
                        <tr>
                            <td>Bil. Rekod</td>
                            <td>Amaun (RM)</td>
                            <td>Bil. Rekod</td>
                            <td>Amaun (RM)</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="dt, index in table.items">
                            <td>{{dt.cara_bayaran}}</td>
                            <td>{{dt.bil_terima}}</td>
                            <td>{{dt.amaun_terima}}</td>
                            <td>{{dt.bil_batal}}</td>
                            <td>{{dt.amaun_batal}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td><b>Jumlah Terimaan Mengikut Jenis</b></td>
                            <td><b>{{table.total_bil_terima}}</b></td>
                            <td><b>{{table.total_amaun_terima}}</b></td>
                            <td><b></b></td>
                            <td><b></b></td>
                        </tr>
                        <tr>
                            <td><b>Bilangan Urusniaga Batal</b></td>
                            <td><b></b></td>
                            <td><b></b></td>
                            <td><b>{{table.total_bil_batal}}</b></td>
                            <td><b>{{table.total_amaun_batal}}</b></td>
                        </tr>
                        <tr>
                            <td><b>Bilangan Urusniaga Diterima</b></td>
                            <td><b>{{table.selisih_bil}}</b></td>
                            <td><b>{{table.selisih_amaun}}</b></td>
                            <td><b></b></td>
                            <td><b></b></td>
                        </tr>
                    </tfoot>
                </table>
                </div>
            </w-flex>

            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
    auth: [Array, Object],
  },
  data() {
    return {
        resourceurl: this.service_laporan+'kutipan/laporan/dummy',
        reload: true,
        loading: false,
        status: [
            {
                value: 1,
                label: 'Aktif',
            },
            {
                value: 2,
                label: 'Tidak Aktif',
            },
        ],
        crumbs: [
            { label: 'iHasil', route: '/' },
            { label: 'Kutipan', route: '/kutipan/laporan/mengikut_jenis' },
            { label: 'Laporan', route: '/kutipan/laporan/mengikut_jenis' },
            { label: 'Mengikut Jenis', route: '/kutipan/laporan/mengikut_jenis' },
          ],
        cari : {tarikh_dari: '', tarikh_hingga: '', jabatan_id: '', lkp_kaunter_id: ''},
        table_akaun: {total_bil_terima: 0, total_amaun_terima:0, total_bil_batal:0, total_amaun_batal:0, total_bil_selisih:0, total_amaun_selisih:0},
    }
  },
  methods: {
    totalBilTerima(values) {
      return values.reduce((acc, val) => {
        return acc + parseInt(val.bil_terima);
      }, 0);    
    },
    totalAmaunTerima(values) {
      var amaun = values.reduce((acc, val) => {
        return acc + parseInt(val.amaun_terima);
      }, 0);   
       return this.$zutil.currency(amaun);
    },
    totalBilBatal(values) {
      return values.reduce((acc, val) => {
        return acc + parseInt(val.bil_batal);
      }, 0);    
    },
    totalAmaunBatal(values) {
      var amaun = values.reduce((acc, val) => {
        return acc + parseInt(val.amaun_batal);
      }, 0);   
       return this.$zutil.currency(amaun);
    },
    selisihBil(values) {
      var terima = values.reduce((acc, val) => {
        return acc + parseInt(val.bil_terima);
      }, 0);    
      var batal = values.reduce((acc, val) => {
        return acc + parseInt(val.bil_batal);
      }, 0);

      return terima - batal;
    },
    selisihAmaun(values) {
      var terima = values.reduce((acc, val) => {
        return acc + parseInt(val.amaun_terima);
      }, 0);    
      var batal = values.reduce((acc, val) => {
        return acc + parseInt(val.amaun_batal);
      }, 0);

      var hasil = terima - batal;

      return this.$zutil.currency(hasil);
    },
    search() {
      this.getQueryData();
      // this.$inertia.visit(window.route('kutipan.laporan.mengikut_jenis')+'?tarikh_dari='+this.cari.tarikh_dari+'&tarikh_hingga='+this.cari.tarikh_hingga+'&jabatan_id='+this.cari.jabatan_id, {preserveScroll:true})
    },

    reset(){
      this.cari = {tarikh_dari: '', tarikh_hingga: '', jabatan_id: '', lkp_kaunter_id: ''}
      this.search()
    },

    cetak() {
        window.open(this.service_laporan+'kutipan/laporan/mengikut_jenis/cetak?user_id='+this.auth.user.id+
            "&tarikh_dari=" + this.cari.tarikh_dari +
            "&tarikh_hingga=" + this.cari.tarikh_hingga+
            '&jabatan_id='+this.cari.jabatan_id+
            '&lkp_kaunter_id='+this.cari.lkp_kaunter_id,'_blank');
    },
    async getQueryData() {
        this.loading = true;
        const resp = await axios.get(
            this.service_laporan + "kutipan/laporan/mengikut_jenis?user_id=" + this.auth.user.id +
                "&tarikh_dari=" + this.cari.tarikh_dari +
                "&tarikh_hingga=" + this.cari.tarikh_hingga +
                "&jabatan_id=" + this.cari.jabatan_id+
                '&lkp_kaunter_id='+this.cari.lkp_kaunter_id
        );
        this.table = resp.data.data;
        this.getByJenisAkaun();
        // this.loading = false;
    },
    async getByJenisAkaun() {
        // console.log('akaun');
        this.loading = true;
        const resp = await axios.get(
            this.service_laporan+'kutipan/laporan/mengikut_jenis_akaun?user_id='+this.auth.user.id+
            "&tarikh_dari=" + this.cari.tarikh_dari +
            "&tarikh_hingga=" + this.cari.tarikh_hingga+
            '&jabatan_id='+this.cari.jabatan_id+
            '&lkp_kaunter_id='+this.cari.lkp_kaunter_id
        );
        this.table_akaun = resp.data.data;
        this.loading = false;
        // this.table_akaun.total_bil_terima = this.totalBilTerima(this.table_akaun.items);
        // this.table_akaun.total_amaun_terima = this.totalAmaunTerima(this.table_akaun.items);
        // this.table_akaun.total_bil_batal = this.totalBilBatal(this.table_akaun.items);
        // this.table_akaun.total_amaun_batal = this.totalAmaunBatal(this.table_akaun.items);
        // this.table_akaun.total_bil_selisih = this.selisihBil(this.table_akaun.items);
        // this.table_akaun.total_amaun_selisih = this.selisihAmaun(this.table_akaun.items);
    },
  },
  watch: {
  },
  mounted() {
    // console.log(this.datas);
    this.dialog.width = 900
    this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.cari.tarikh_dari == 'undefined'){this.cari.tarikh_dari = ''}
    if(this.cari.tarikh_hingga == 'undefined'){this.cari.tarikh_hingga = ''}
    if(this.cari.jabatan_id == 'undefined'){this.cari.jabatan_id = ''}
    if(this.cari.lkp_kaunter_id == 'undefined'){this.cari.lkp_kaunter_id = ''}
    // this.getByJenisAkaun();
    // console.log(this.auth.user);
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>